export const MOUNT_SELECTOR = '.vue-award-mount'

/* TIME_DEATH_DAY - время, на которое должен исчезнуть баннер после закрытия */
export const TIME_DEATH_DAY = 1 / 2 // половина дня, или 12 часов

export const IMAGE_AWARD_PREMIUM = {
  src: '/static/_v1/pd/pictures/award/award.jpg',
  alt: 'Премия ПроДокторов',
}

export const IMAGE_AWARD_GRAND_PRIX = {
  src: '/static/_v1/pd/pictures/award/grand-prix.jpg',
  alt: 'Гран-при премии ПроДокторов',
}

const EVENT_YEAR = 2025

export const EVENT_DATES = [
  new Date(EVENT_YEAR, 9, 1, 0, 0, 0), // 01.10.2025 - анонс премии
  new Date(EVENT_YEAR, 10, 5, 0, 0, 0), // 05.11.2025 - результаты премии (ручной запуск)
  new Date(EVENT_YEAR, 10, 11, 0, 0, 0), // 11.11.2025 - 1 анонс Гран-при
  new Date(EVENT_YEAR, 10, 21, 0, 0, 0), // 21.11.2025 - 2 анонс Гран-при
  new Date(EVENT_YEAR, 10, 22, 0, 0, 0), // 22.11.2025 - 3 анонс Гран-при
  new Date(EVENT_YEAR, 10, 22, 17, 0, 0), // 22.11.2025 17:00 - Гран-при - появление ссылки на трансляцию
  new Date(EVENT_YEAR, 10, 23, 0, 0, 0), // 23.11.2025 - результаты Гран-при
]

export const CONTENT_BY_DATE = [
  {
    isDarkMode: false,
    banner: {
      title: `Всероссийская премия ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/p1cGWKoo',
      },
    },
  },
  {
    isDarkMode: false,
    banner: {
      title: `Результаты премии ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/jfcBXfPB',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Гран-при премии ПроДокторов ${EVENT_YEAR} пройдёт 22 ноября`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Гран-при премии ПроДокторов ${EVENT_YEAR}. Начало трансляции завтра в 17:00 (мск)`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Скоро трансляция Гран-при премии ПроДокторов ${EVENT_YEAR}. Начало трансляции в 17:00 (мск)`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Смотреть трансляцию Гран-при премии ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Смотреть',
        moreLink: 'https://vkvideo.ru/video-120057026_456239641',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Результаты  Гран-при премии ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
]
